import { render } from "./RowComponent.vue?vue&type=template&id=f23e55d0"
import script from "./RowComponent.vue?vue&type=script&lang=js"
export * from "./RowComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__